const venues = {


    1 : { xs: 12, sm: 12, md: 12, lg: 12, xl: 12 },
    2 : { xs: 12, sm: 6, md: 6, lg: 6, xl: 6 },
    3 : { xs: 12, sm: 6, md: 4, lg: 3, xl: 3 },
    4 : { xs: 12, sm: 6, md: 6, lg: 3, xl: 3 },
    5 : { xs: 12, sm: 6, md: 3, lg: 3, xl: 3 },
    6 : { xs: 12, sm: 6, md: 3, lg: 3, xl: 3 },
    7 : { xs: 12, sm: 6, md: 3, lg: 3, xl: 3 },


}

export default venues;